import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { useState } from "react";
import useInputChange from "../../../utils/hooks/useInputChange";
import { isEmptyObject } from "../../../utils/validators/validators";
import Form from "../../form/Form";
import { updateStaffNextOfKinInfo } from "../../../redux/slice/staff/staffSlice";
import PhoneInput from "react-phone-number-input";

function NextOfKinInfo() {
  const [hasEditStaff, setHasEditStaff] = useState();
  const [nextOfKinInfo, setNextOfKinInfo] = useState({});
  const dispatch = useDispatch();

  const [editing, setEditing] = useState(false);
  const [error, setError] = useState({});

  const { next_kin_information } = useSelector(
    (state) => state?.staff.staff_information
  );
  const { user_permissions } = useSelector((state) => state.auth?.user);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [borderColor, setBorderColor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handlePhoneNumberChange = (phone_no) => {
    if (!phone_no) {
      setBorderColor("red");
      setErrorMessage("Please enter phone number ");
    } else {
      setBorderColor("");
      setErrorMessage("");

      setPhoneNumber(phone_no);
    }
    setStaffInputData(staffInputData);
  };

  // Update Personal Info
  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      dispatch(
        updateStaffNextOfKinInfo({
          ...staffInputData,
          phone_number: phoneNumber,
        })
      );
    }
  };

  // declare input fields variables
  const [staffInputData, setStaffInputData] = useState({
    first_name: "",
    last_name: "",
    middle_name: "",
    email: "",
    relationship: "",
    contact_address: "",
  });

  // Custom hook for input change
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  const resetOnClose = () => {
    setEditing(editing ? false : true);
    setBorderColor("");
    setErrorMessage("");
    setPhoneNumber(nextOfKinInfo?.phone_number);
    setStaffInputData({
      ...staffInputData,
      first_name: nextOfKinInfo?.first_name,
      last_name: nextOfKinInfo?.last_name,
      middle_name: nextOfKinInfo?.middle_name,
      email: nextOfKinInfo?.email,
      relationship: nextOfKinInfo?.relationship,
      contact_address: nextOfKinInfo?.contact_address,
      id: nextOfKinInfo?.id,
    });
  };

  useEffect(() => {
    setNextOfKinInfo(next_kin_information);
    if (next_kin_information) {
      setStaffInputData({
        ...staffInputData,
        first_name: nextOfKinInfo?.first_name,
        last_name: nextOfKinInfo?.last_name,
        middle_name: nextOfKinInfo?.middle_name,
        email: nextOfKinInfo?.email,
        relationship: nextOfKinInfo?.relationship,
        contact_address: nextOfKinInfo?.contact_address,
        id: nextOfKinInfo?.id,
      });
      setPhoneNumber(nextOfKinInfo?.phone_number);
    }
  }, [next_kin_information]);

  useEffect(() => {
    setHasEditStaff(
      user_permissions?.some((permission) => permission.name === "edit staff")
    );
  }, [user_permissions]);

  return (
    <div className='border p-4 rounded-3 mt-4 px-3 position-relative'>
      <h4 className='fw-bolder text-primary bg-white position-absolute profile-title'>
        Next Of Kin Information
      </h4>

      {next_kin_information ? (
        <>
          <Form
            setError={(e) => {
              if (!phoneNumber) {
                setBorderColor("#fa5c7c");
                setErrorMessage("phone number is required.");
              }
              setError(e);
            }}
            submitHandler={handleSubmit}
            values={staffInputData}
          >
            <div className='row shadow-lg p-2 mb-2'>
              <div className='col-xs-6 col-sm-6 col-md-3'>
                <h5>First Name</h5>
                {!editing && <p>{next_kin_information.first_name}</p>}
                {editing && (
                  <input
                    className={`form-control update-input ${
                      error.first_name && "is-invalid"
                    }`}
                    minLength='2'
                    maxLength='255'
                    textname='first name'
                    type='text'
                    name='first_name'
                    value={input.first_name}
                    onChange={handleChange}
                    placeholder='First Name'
                    id='first_name'
                  />
                )}
                {error.first_name && (
                  <span className='invalid-feedback'>{error.first_name}</span>
                )}
              </div>
              <div className='col-xs-6 col-sm-6 col-md-3'>
                <h5>Last Name</h5>
                {!editing && <p>{next_kin_information.last_name}</p>}
                {editing && (
                  <input
                    className={`form-control update-input ${
                      error.last_name && "is-invalid"
                    }`}
                    minLength='2'
                    maxLength='255'
                    textname='last name'
                    value={input.last_name}
                    onChange={handleChange}
                    placeholder='Last Name'
                    type='text'
                    name='last_name'
                    id='last_name'
                  />
                )}
                {error.last_name && (
                  <span className='invalid-feedback'>{error.last_name}</span>
                )}
              </div>
              <div className='col-xs-6 col-sm-6 col-md-3'>
                <h5>Middle Name</h5>
                {!editing && <p>{next_kin_information.middle_name}</p>}
                {editing && (
                  <input
                    className={`form-control update-input ${
                      error.middle_name && "is-invalid"
                    }`}
                    minLength='2'
                    maxLength='255'
                    textname='middle name'
                    value={input.middle_name}
                    onChange={handleChange}
                    placeholder='Middle Name'
                    type='text'
                    name='middle_name'
                    id='middle_name'
                  />
                )}
                {error.middle_name && (
                  <span className='invalid-feedback'>{error.middle_name}</span>
                )}
              </div>
              <div className='col-xs-6 col-sm-6 col-md-3'>
                <h5>Email Adress</h5>
                {!editing && <p>{next_kin_information.email}</p>}
                {editing && (
                  <input
                    className={`form-control update-input ${
                      error.email && "is-invalid"
                    }`}
                    minLength='2'
                    maxLength='255'
                    textname='email'
                    value={input.email}
                    onChange={handleChange}
                    placeholder='Email'
                    type='text'
                    name='email'
                    id='email'
                  />
                )}
                {error.email && (
                  <span className='invalid-feedback'>{error.email}</span>
                )}
              </div>
            </div>
            {/* <hr /> */}
            <div className='row shadow-lg p-2'>
              <div className='col-xs-6 col-sm-4 col-md-3'>
                <h5>Phone Number</h5>
                {!editing && <p>{next_kin_information.phone_number}</p>}
                {editing && (
                  <>
                    <PhoneInput
                      placeholder='Enter phone number'
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setBorderColor("red");
                          setErrorMessage("Please enter phone number");
                        } else {
                          setBorderColor("");
                          setErrorMessage("");
                        }
                      }}
                      defaultCountry={null}
                      className='form-control custom-phone-input'
                      style={{ borderColor: `${borderColor}` }}
                    />
                    {errorMessage && (
                      <span
                        className='text-danger'
                        style={{ fontSize: "12px" }}
                      >
                        {errorMessage}
                      </span>
                    )}
                  </>
                )}
              </div>
              <div className='col-xs-6 col-sm-4 col-md-3'>
                <h5>Relationship With Employee</h5>
                {!editing && <p>{next_kin_information.relationship}</p>}
                {editing && (
                  <input
                    className={`form-control update-input ${
                      error.relationship && "is-invalid"
                    }`}
                    minLength='2'
                    maxLength='20'
                    textname='relationship'
                    value={input.relationship}
                    onChange={handleChange}
                    placeholder='Relationship'
                    type='text'
                    name='relationship'
                    id='relationship'
                  />
                )}
                {error.relationship && (
                  <span className='invalid-feedback'>{error.relationship}</span>
                )}
              </div>
              <div className='col-sm-4 col-md-6'>
                <h5>Contact Address</h5>
                {!editing && <p>{next_kin_information.contact_address}</p>}
                {editing && (
                  <textarea
                    className={`form-control update-input ${
                      error.contact_address && "is-invalid"
                    }`}
                    min='2'
                    max='255'
                    textname='contact address'
                    value={input.contact_address}
                    onChange={handleChange}
                    placeholder='Contact Address'
                    type='text'
                    name='contact_address'
                    id='contact_address'
                    cols='70'
                    rows='3'
                  ></textarea>
                )}
                {error.contact_address && (
                  <span className='invalid-feedback'>
                    {error.contact_address}
                  </span>
                )}
              </div>
            </div>
            {/* <hr /> */}
            {hasEditStaff && (
              <div className='d-flex float-end '>
                <div>
                  <a
                    className={`btn btn-${
                      editing ? "warning" : "info"
                    } btn-sm mt-3 px-4 text-white`}
                    onClick={() => resetOnClose()}
                  >
                    {editing ? "Close" : "Edit"}
                  </a>
                  {editing && (
                    <button className='btn btn-success ms-2 btn-sm mt-3 px-4'>
                      Save
                    </button>
                  )}
                </div>
              </div>
            )}
          </Form>
          <div className='clearfix'></div>
        </>
      ) : (
        <div className='alert alert-info'>No Record Found</div>
      )}
    </div>
  );
}

export default NextOfKinInfo;
